// front.js
import { createApp } from 'vue';
import Router from '@/front/routes.js';
import Main from '@/front/views/shared/Main.vue';
import Axios from "axios";
import { setupPiniaMonitoring } from '@/front/performance/PiniaPerformanceMonitor.js'
import { StateChangeProfiler } from '@/front/performance/StateChangeProfiler.js'
import { LoggerPlugin } from '@/plugins/logger';
// import * as Sentry from "@sentry/vue";


const app = createApp(Main);

// API + Axios wrapper
import { createApi } from '@/plugins/api';
const Api = createApi({ handler: Axios, namespace: '' });

// Pinia + API setup  
import { createPinia } from 'pinia';
const Pinia = createPinia();
if (window.location.href.includes("goperf=1")) {
  const monitor = setupPiniaMonitoring(app, { manualOnly: true })
}
Pinia.use(({ store }) => {
  store.Api = Api;
  store.router = Router;
})

import PrimeVue from 'primevue/config';
import Lara from '@/front/presets/lara';      //import preset 
import VuePapaParse from 'vue-papa-parse'
// import Tooltip from 'primevue/tooltip';
import FloatingVue from 'floating-vue'
// import 'floating-vue/dist/style.css'
import ConfirmationService from 'primevue/confirmationservice';
import ToastService from 'primevue/toastservice';
import Toast from 'primevue/toast';
import ConfirmDialog from 'primevue/confirmdialog';
import safeHtml from '@/front/directives/safe-html.js'

// I18n loader
import { createI18n } from 'vue-i18n';
const I18n = createI18n({ locale: 'current', messages: translations, legacy: false });

app.use(Router)
  .use(Pinia)
  .use(I18n)
  .use(Api)
  .use(VuePapaParse)

app.use(PrimeVue, {
  pt: Lara,
  unstyled: true,
}).use(ConfirmationService)
  .use(ToastService);

app.use(LoggerPlugin, { captureErrors: true });


app.directive('safe-html', safeHtml)

app.component('Toast', Toast);
app.component('ConfirmDialog', ConfirmDialog);
window.toast = app.config.globalProperties.$toast;

// app.directive('tooltip', Tooltip);
app.use(FloatingVue, {
  themes: {
    light: {
      distance: 10,
      tether: true,
    }
  },
  placement: 'top',
});

// Start monitoring in development
if (window.location.href.includes("goperf=1")) {
  // Setup monitoring
  const stateProfiler = new StateChangeProfiler()


  // Profile your stores after they're created
  setTimeout(() => {
    const stores = app.config.globalProperties.$pinia._s
    stores.forEach(store => stateProfiler.profileStore(store))
  }, 1000)

  // After everything is loaded, wrap only the methods you care about
  setTimeout(() => {
    window.piniaMonitor.wrapTargetMethods();
  }, 2000);
}

app.mount('#app')

